import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class NvDataBaseApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'nvDataBase';
    }

    /**
     * 创建数据库
     */
    public createDataBase(dbId) {
        return this.send({ dbId }, "createDataBase", Methods.GET);
    }

    /**
     * 批量修改表
     * @param erModelId 
     * @param devProd 
     * @returns 
     */
    public batchCreateOrChangeTable(erModelId: number, devProd: "dev" | "gray" | "prod" = "dev") {
        return this.send({ erModelId, devProd }, "batchCreateOrChangeTable", Methods.GET);
    }

    /**
     * 批量修改字段
     * @param tableId 
     * @param devProd 
     * @returns 
     */
    public batchCreateOrChangeColum(tableId: number, devProd: "dev" | "gray" | "prod" = "dev") {
        return this.send({ tableId, devProd }, "batchCreateOrChangeColum", Methods.GET);
    }

    /**
     * 批量修改索引
     * @param tableId 
     * @param devProd 
     * @returns 
     */
    public batchCreateOrChangeIndex(tableId: number) {
        return this.send({ tableId }, "batchCreateOrChangeIndex", Methods.GET);
    }

    /**
     * 执行SQL
     * @param dbId 
     * @param devProd 
     * @param sql 
     */
    public executeSql(dbId: string, devProd: string, sql: string) {
        return this.send({ dbId, devProd, sql }, 'executeSql', Methods.GET);
    }


    /**
     * 查询sql
     * @param dbId
     * @param devProd
     * @param sql
     */
    public executeSqlNew(dbId: string, devProd: string, sql: string) {
        return this.send({ dbId, devProd, sql }, 'executeSqlNew', Methods.GET);
    }


    /**
     * 获取Table数据
     * @param tableId 
     * @param devProd 
     * @param page 
     * @param itemsPerPage 
     * @returns 
     */
    public getTableData(tableId: number, devProd: string, page: number, itemsPerPage: number, selectDbId: any=0) {
        return this.send({ tableId, devProd, page, itemsPerPage, selectDbId}, "getTableData", Methods.GET);
    }

    /**
     * 保存数据
     * @param tableId 
     * @param devProd 
     * @param datas 
     * @returns 
     */
    public savesTableData(tableId: number, devProd: string, datas) {
        return this.send(datas, `saves?tableId=${tableId}&devProd=${devProd}`, Methods.POST);
    }

    /**
     * 删除数据
     * @param tableId 
     * @param devProd 
     * @param id 
     * @returns 
     */
    public deleteTableData(tableId: number, devProd: string, id: number) {
        return this.send({ tableId, devProd, id }, "delete", Methods.GET)
    }

    /**
     * 相同环境同步数据库
     * @param params
     */
    public databaseTransferIdentical(params) {
        return this.send(params, "dataTransferIdentical", Methods.POST)
    }

    /**
     * 不同环境数据拉取
     * @param params
     */
    public dataTransferDifferent(params) {
        return this.send(params, "dataTransferDifferent", Methods.POST)
    }

}
